import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter';
import {
  DigitalCaseflowActivityErrorLog,
  DigitalCaseflowActivityErrorLogAdapter
} from '@secca/shared/models/digital-caseflow-activity-error-log';
import {
  DigitalCaseflowValidationErrorLog,
  DigitalCaseflowValidationErrorLogAdapter
} from '@secca/shared/models/digital-caseflow-validation-error-log';
export class DigitalCaseflowActivityLog {
  activityType: string;
  activityName: string;
  result: string;
  activityErrorLogs: DigitalCaseflowActivityErrorLog[];
  validationErrorLogs: DigitalCaseflowValidationErrorLog[];

  public constructor(init?: Partial<DigitalCaseflowActivityLog>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class DigitalCaseflowActivityLogAdapter implements Adapter<DigitalCaseflowActivityLog> {

  constructor(private digitalCaseflowActivityErrorLogAdapter: DigitalCaseflowActivityErrorLogAdapter,
              private digitalCaseflowValidationErrorLogAdapter: DigitalCaseflowValidationErrorLogAdapter) {}

  adapt(item: any): DigitalCaseflowActivityLog {
    return new DigitalCaseflowActivityLog({
      activityType: item.activityType,
      activityName: item.activityName,
      result: item.result,
      activityErrorLogs: item.activityErrorLogs.map(error => this.digitalCaseflowActivityErrorLogAdapter.adapt(error)),
      validationErrorLogs: item.validationErrorLogs.map(error => this.digitalCaseflowValidationErrorLogAdapter.adapt(error)),
    });
  }
}
